import Vue from 'vue'
import VueRouter from 'vue-router'
import api from "@/api.js";
import store from "@/store/index.js"

Vue.use(VueRouter)

const routes = [
  {
    path: '/events',
    name: 'Events',
    component: () => import("@/views/Events.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import("@/views/Users.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/wpusers',
    name: 'WPUsers',
    component: () => import("@/views/WebPos.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/pkpass/:id',
    name: 'PkpassEditor',
    component: () => import("@/views/PkpassEditor.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import("@/views/Activities.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/merchants',
    name: 'FreeMerchants',
    component: () => import("@/views/FreeMerchants.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import("@/views/Logs.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import("@/views/Mobile.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: () => import("@/views/Transactions.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import("@/views/Logs.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/Login.vue"),
    meta: {
      auth: false,
    },
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(function (to, from, next) {
  if (to.meta.auth) {
    if (store.state.user.userData == null) {
      api.ping().then(response => {
        if (!response.user || !response.user.idx) {
          next('/login');
        } else {
          next();
        }
      }).catch(() => {
        next('/login');
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router
